import React, { Component } from 'react';
import { Ref } from "./App.js";

export class Main extends Component {
  state = { menu: 1}
  componentDidMount = this.click;

  click(num = 1) {
    this.setState({ menu: num})
    Ref.Act.current.setActive(num);
  }

  active(menu) {
    return this.state.menu == menu ? "active" : "";
  }

  render() {
    return (
      <div className="main-container">   
        <div className="main-navigation navbar-collapse collapse">
          <ul className="main-navigation-menu">
            <li className={this.active(1)}>
              <a onClick={() => this.click(1)}><i className="fa fa-plus-square"></i>
                <span className="title">Požadavky - aktivní</span>
              </a>
            </li>
            <li className={this.active(0)}>
              <a onClick={() => this.click(0)}><i className="fa fa-square"></i>
                <span className="title">Požadavky - všechny</span>
              </a>
            </li>
            <li className={this.active(2)}>
              <a onClick={() => this.click(2)}><i className="fa fa-minus-square"></i>
                <span className="title">Požadavky - neaktivní</span>
              </a>
            </li>
          </ul>
        </div>
        {this.props.children}
      </div>
    );
  }
}